import { createElement } from 'react';

/**
 * Higher-order component (HOC) factory that returns the given component wrapped
 * with expected micro-frontend methods.
 */
function createMicroFrontend({ Component, onMicroFrontendLoadError, onMicroFrontendLoad, }) {
    const WrappedComponent = (props) => createElement(Component, props);
    WrappedComponent.displayName = `MicroFrontend(${Component.displayName || Component.name})`;
    WrappedComponent.onMicroFrontendLoad =
        onMicroFrontendLoad.bind(WrappedComponent);
    WrappedComponent.onMicroFrontendLoadError =
        onMicroFrontendLoadError.bind(WrappedComponent);
    // @todo Re-enable when data fetching is implemented. See WEBEX-1226.
    // WrappedComponent.fetchData = fetchDataWrapper<P>(
    //     WrappedComponent,
    //     fetchData,
    // );
    // WrappedComponent.getGraphQLFragments = getGraphQLFragmentsWrapper(
    //     WrappedComponent,
    //     getGraphQLFragments,
    // );
    return WrappedComponent;
}

export { createMicroFrontend };
